import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { HelmetProvider } from 'react-helmet-async';
import './App.css';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import ScrollToAnchor from './components/ScrollToAnchor';
import { Toaster } from './components/ui/sonner';

// Pages
import HomePage from './pages/HomePage';
import FeaturesPage from './pages/FeaturesPage';
import HowItWorksPage from './pages/HowItWorksPage';
import SupportPage from './pages/SupportPage';
import PricingPage from './pages/PricingPage';
import FAQPage from './pages/FAQPage';
import ContactPage from './pages/ContactPage';
import TermsPage from './pages/TermsPage';
import PrivacyPage from './pages/PrivacyPage';
import AdminPage from './pages/AdminPage';
import FlyerPage from './pages/FlyerPage';
import PitchBanner from './pages/PitchBanner';

function App() {
  return (
    <HelmetProvider>
      <Router>
        <ScrollToTop />
        <ScrollToAnchor />
        <div className="min-h-screen bg-[color:var(--bg)]">
          <Navbar />
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/vyuziti" element={<FeaturesPage />} />
            <Route path="/jak-zacit" element={<HowItWorksPage />} />
            <Route path="/podpora" element={<SupportPage />} />
            <Route path="/cenik" element={<PricingPage />} />
            <Route path="/faq" element={<FAQPage />} />
            <Route path="/kontakt" element={<ContactPage />} />
            <Route path="/podminky" element={<TermsPage />} />
            <Route path="/ochrana-udaju" element={<PrivacyPage />} />
            <Route path="/dashboard-x7k9p2q" element={<AdminPage />} />
            <Route path="/letak" element={<FlyerPage />} />
            <Route path="/pitch" element={<PitchBanner />} />
          </Routes>
          <Footer />
          <Toaster />
        </div>
      </Router>
    </HelmetProvider>
  );
}

export default App;
